import { render, staticRenderFns } from "./CourseraBillingPlan.vue?vue&type=template&id=5d2179f6&scoped=true&"
import script from "./CourseraBillingPlan.vue?vue&type=script&lang=ts&"
export * from "./CourseraBillingPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraBillingPlan.vue?vue&type=style&index=0&id=5d2179f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2179f6",
  null
  
)

export default component.exports